// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const dni: CountryValidator<"ES"> = createValidator(
  "es.dni",
  66,
);

export default dni;
export const compact = dni.compact;
export const format = dni.format;
export const validate = dni.validate;
export const generate = (): string =>
  dni.generate?.() ??
  (() => {
    throw new Error(
      "Validator es.dni cannot generate values",
    );
  })();
export const CHECK_LETTERS = "TRWAGMYFPDXBNJZSQVHLCKE";
